module.exports = __webpack_public_path__ + "img/zippo4.8d166168.webp";